import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";

import { API, STRIPEPUBLICKEY, STRIPESECRETKEY } from "../../backend";
import authHeader from "../../services/auth-header";
import GetCompanyInfoService from "../../services/company/getCompanyInfoService";
import EditCompanyService from "../../services/company/editCompanyService";

function PaymentSuccess() {
  let navigate = useNavigate()
  const [stripedata, setStripdata] = useState([])
  const [companydata, setCompany] = useState([])
  const [pacakge, setPackage] = useState([])
  const queryParams = new URLSearchParams(window.location.search)
  const session_id = queryParams.get("session_id")

  const handlePremium = async () => {
    const response = await fetch(`https://api.stripe.com/v1/checkout/sessions/${session_id}`, {
      headers: {
        Authorization: `Bearer ${STRIPESECRETKEY}`
      }
    })
    const get = (await response.json())
    setStripdata(get)
  }

  const company = () => {
    GetCompanyInfoService.getCompanyInfo().then(
      (response) => {
        setCompany(response.data)
      })
  }

  const packagedata = async () => {
    const res = await fetch(API + "company/packages/", { headers: authHeader() });
    const getcon = await res.json();
    setPackage(getcon)
  }
  const plan = pacakge.filter((value) => value.year_price === stripedata.amount_total / 100)
  const editcompany = () => {

    EditCompanyService.editplan(
      plan[0].id
    ).then(
      (response) => {
        if (response.data.success) {
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
        }
      })
  }

  useEffect(() => {
    handlePremium()
    company()
    packagedata()
  }, [])

  useEffect(() => {
    if (plan.length > 0) {
      editcompany()
    }
  }, [plan])

  return (
    <>
      <div className="container-fluid pt-8">
        <div className="cardsucess bodysucess justify-content-center">
          <div className="divsucess" style={{ height: '100px', width: '100px' }}>
            <i className="checkmark isucess" style={{ lineHeight: '100px', fontSize: '50px', marginLeft: '-7px' }}>✓</i>
          </div>

          <h1 className="hsucess">Your payment success!</h1>
          <p className="psucess">Thank you, your payment has been procced successfully, please check your email for login</p><br />
          <button type="button" class="btn btn-primary btn-lg"
            onClick={() => navigate('/login')}
          >Go to your dashboard</button>
        </div>
      </div>

    </>
  );
}

export default PaymentSuccess;
